/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './paramedic.reducer';

export const ParamedicDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const paramedicEntity = useAppSelector(state => state.paramedic.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="paramedicDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.paramedic.detail.title">Paramedic</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.paramedic.id">Id</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.id}</dd>
          <dt>
            <span id="education">
              <Translate contentKey="tinyMedicRestApp.paramedic.education">Education</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.education}</dd>
          <dt>
            <span id="training">
              <Translate contentKey="tinyMedicRestApp.paramedic.training">Training</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.training}</dd>
          <dt>
            <span id="experience">
              <Translate contentKey="tinyMedicRestApp.paramedic.experience">Experience</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.experience}</dd>
          <dt>
            <span id="achievements">
              <Translate contentKey="tinyMedicRestApp.paramedic.achievements">Achievements</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.achievements}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.paramedic.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.paramedic.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.paramedic.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.paramedic.active">Active</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.paramedic.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.cursor}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.paramedic.name">Name</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.name}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.paramedic.email">Email</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.email}</dd>
          <dt>
            <span id="visitCharge">
              <Translate contentKey="tinyMedicRestApp.paramedic.visitCharge">Visit Charge</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.visitCharge}</dd>
          <dt>
            <span id="age">
              <Translate contentKey="tinyMedicRestApp.paramedic.age">Age</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.age}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.paramedic.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.gender}</dd>
          <dt>
            <span id="mobile">
              <Translate contentKey="tinyMedicRestApp.paramedic.mobile">Mobile</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.mobile}</dd>
          <dt>
            <span id="dateOfBirth">
              <Translate contentKey="tinyMedicRestApp.paramedic.dateOfBirth">Date Of Birth</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.dateOfBirth}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.paramedic.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.bloodGroup}</dd>
          <dt>
            <span id="paramedicType">
              <Translate contentKey="tinyMedicRestApp.paramedic.paramedicType">Paramedic Type</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.paramedicType}</dd>
          <dt>
            <span id="registrationCode">
              <Translate contentKey="tinyMedicRestApp.paramedic.registrationCode">Registration Code</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.registrationCode}</dd>
          <dt>
            <span id="registrationNumber">
              <Translate contentKey="tinyMedicRestApp.paramedic.registrationNumber">Registration Number</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.registrationNumber}</dd>
          <dt>
            <span id="registrationValidUpto">
              <Translate contentKey="tinyMedicRestApp.paramedic.registrationValidUpto">Registration Valid Upto</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.registrationValidUpto}</dd>
          <dt>
            <span id="knownLanguages">
              <Translate contentKey="tinyMedicRestApp.paramedic.knownLanguages">Known Languages</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.knownLanguages}</dd>
          <dt>
            <span id="qualification">
              <Translate contentKey="tinyMedicRestApp.paramedic.qualification">Qualification</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.qualification}</dd>
          <dt>
            <span id="practicingCity">
              <Translate contentKey="tinyMedicRestApp.paramedic.practicingCity">Practicing City</Translate>
            </span>
          </dt>
          <dd>{paramedicEntity.practicingCity}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedic.user">User</Translate>
          </dt>
          <dd>{paramedicEntity.user ? paramedicEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedic.contactCode">Contact Code</Translate>
          </dt>
          <dd>{paramedicEntity.contactCode ? paramedicEntity.contactCode.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/paramedic" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/paramedic/${paramedicEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParamedicDetail;
